import { transformForSubmit } from 'platform/forms-system/src/js/helpers';
import { cloneDeep } from 'lodash-es';
import {
  transformPhoneNumberObject,
  transformMailingAddress,
  todaysDate,
} from '../helpers';

export default function transform(formConfig, form) {
  const data = cloneDeep(form.data);

  /**
   * Note: Both spellings of the agreed field should no longer need to be deleted after all
   * previously created Save in Progress forms have been successfully submitted or expired.
   * After the default time for SiP, the following 2 lines should be able to be removed.
   */
  delete data.agreed;
  delete data.AGREED;
  delete data.statementOfTruthCertified;
  delete data.vaFileNumberLast4;
  delete data.ssnLast4;

  // since we're using the prefill/ContactInfo pattern for managing
  // the users address, phones, and email all the relevant data is
  // under the `veteran` key within formData buy default. We need
  // to extract and alter the shape a bit to conform to our schema
  data.homePhone = transformPhoneNumberObject(data.veteran.homePhone);
  data.mobilePhone = transformPhoneNumberObject(data.veteran.mobilePhone);
  if (data.homePhone === '') {
    delete data.homePhone;
  }
  if (data.mobilePhone === '') {
    delete data.mobilePhone;
  }
  data.mailingAddress = transformMailingAddress(data.veteran.mailingAddress);
  data.emailAddress = data.veteran.email?.emailAddress;
  delete data.veteran;

  // Make sure testCost is sent as a number
  if (data.testCost) {
    data.testCost = parseFloat(data.testCost);
  }

  // Organization address is assumed to be within the US
  data.organizationAddress.country = 'USA';

  // If the user uploaded supporting documents for BIA, then it got disabled, remove those supporting documents before submission
  if (!data['view:form0803BenefitsIntakeSubmission']) {
    delete data.supportingDocuments;
  }

  // Set dateSigned
  data.dateSigned = todaysDate();

  const submitData = transformForSubmit(formConfig, { ...form, data });

  return JSON.stringify({
    educationBenefitsClaim: {
      form: submitData,
    },
  });
}
